export function eligibleAlert(session, event) {
  return !!session && session.active === true &&
    String(session.accountId) === String(event.accountId) &&
    (event.userId == null || String(session.userId) === String(event.userId)) &&
    Number.isFinite(event.createdAt) && event.createdAt >= session.startedAt &&
    typeof event.key === 'string' && event.key.length > 0;
}

export function messageAlert(message, session) {
  return {
    accountId: message.devlive_account_id,
    createdAt: message.devlive_created_at,
    key: `message:${message.id}`,
    userId: session?.userId,
  };
}
